import { render } from "./TextControl.vue?vue&type=template&id=641e3fc8&scoped=true"
import script from "./TextControl.vue?vue&type=script&lang=js"
export * from "./TextControl.vue?vue&type=script&lang=js"

import "./TextControl.vue?vue&type=style&index=0&id=641e3fc8&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641e3fc8"]])

export default __exports__